import cache from "apollo/cache";
import client from "apollo/client";
import {
  CreateGroupsDocument,
  CreateGroupsMutation,
  CreateGroupsMutationVariables,
} from "graphqlBase/Groups/__generated__/createGroups";
import { GroupCreateType } from "graphqlBase/types";
import { useState } from "react";

const usePersistGroups = () => {
  const [loading, setLoading] = useState(false);

  const handleAdd = async (group: GroupCreateType) => {
    const variables = { groups: [group] };
    setLoading(true);
    return await client
      .mutate<CreateGroupsMutation, CreateGroupsMutationVariables>({
        mutation: CreateGroupsDocument,
        variables,
      })
      .then((result) => {
        try {
          cache.modify({
            fields: {
              groups(existingGroupRefs) {
                return [...existingGroupRefs, group];
              },
            },
          });
        } catch (cacheError) {
          console.error("cache update failed after create group", cacheError);
        }

        return result?.data?.createGroups?.[0]?.id;
      })
      .catch((e: unknown) => {
        console.error("handle add group error", e instanceof Error ? e.message : e);
        throw e;
      })
      .finally(() => setLoading(false));
  };
  return { handleAdd, loading };
};

export default usePersistGroups;
